var App = {
    SlideShow: function () {
        if ($(".Slideshow__Carousel").length) {
            var carousel = $('.Slideshow__Carousel').flickity();
            var flkty = carousel.data('flickity');

            // Total Slide
            if ($(".arrows-slide-wrapper .number_slide").length) {
                $(".arrows-slide-wrapper .total_slide").text(flkty.slides.length);
            }

            if (flkty.selectedIndex == 0) {
                $(".arrows-slide-wrapper .flickity-prev-next-button.previous").addClass("disable");
            } else {
                $(".arrows-slide-wrapper .flickity-prev-next-button.previous").removeClass("disable");
            }

            if (flkty.selectedIndex == (flkty.slides.length - 1)) {
                $(".arrows-slide-wrapper .flickity-prev-next-button.next").addClass("disable");
            } else {
                $(".arrows-slide-wrapper .flickity-prev-next-button.next").removeClass("disable");
            }

            carousel.on('select.flickity', function (event, progress) {
                var index_slide = flkty.selectedIndex + 1;
                numberSlide(index_slide);
                if (flkty.selectedIndex == 0) {
                    $(".arrows-slide-wrapper .flickity-prev-next-button.previous").addClass("disable");
                } else {
                    $(".arrows-slide-wrapper .flickity-prev-next-button.previous").removeClass("disable");
                }

                if (flkty.selectedIndex == (flkty.slides.length - 1)) {
                    $(".arrows-slide-wrapper .flickity-prev-next-button.next").addClass("disable");
                } else {
                    $(".arrows-slide-wrapper .flickity-prev-next-button.next").removeClass("disable");
                }
            });

            if ($(".arrows-slide-wrapper").length) {
                $(".arrows-slide-wrapper .flickity-prev-next-button.previous").on("click", function () {
                    flkty.previous();
                });
                $(".arrows-slide-wrapper .flickity-prev-next-button.next").on("click", function () {
                    flkty.next();
                });
            }

            function numberSlide(index_slide) {
                if ($(".arrows-slide-wrapper .number_slide").length) {
                    $(".arrows-slide-wrapper .current_slide").text(index_slide);
                }
            }
        }
    },
    SlideTheLook: function () {
        if ($(".ShopTheLook__ProductList.hidden-pocket").length) {
            var carousel = $('.ShopTheLook__ProductList.hidden-pocket').flickity();
            var flkty = carousel.data('flickity');

            // Total Slide
            if ($(".arrows-ShopTheLook .number_slide").length) {
                $(".arrows-ShopTheLook .total_slide").text(flkty.slides.length);
            }

            if (flkty.selectedIndex == 0) {
                $(".arrows-ShopTheLook .flickity-prev-next-button.previous").addClass("disable");
            } else {
                $(".arrows-ShopTheLook .flickity-prev-next-button.previous").removeClass("disable");
            }

            if (flkty.selectedIndex == (flkty.slides.length - 1)) {
                $(".arrows-ShopTheLook .flickity-prev-next-button.next").addClass("disable");
            } else {
                $(".arrows-ShopTheLook .flickity-prev-next-button.next").removeClass("disable");
            }

            carousel.on('select.flickity', function (event, progress) {
                var index_slide = flkty.selectedIndex + 1;
                numberSlide(index_slide);

                if (flkty.selectedIndex == 0) {
                    $(".arrows-ShopTheLook .flickity-prev-next-button.previous").addClass("disable");
                } else {
                    $(".arrows-ShopTheLook .flickity-prev-next-button.previous").removeClass("disable");
                }

                if (flkty.selectedIndex == (flkty.slides.length - 1)) {
                    $(".arrows-ShopTheLook .flickity-prev-next-button.next").addClass("disable");
                } else {
                    $(".arrows-ShopTheLook .flickity-prev-next-button.next").removeClass("disable");
                }

                if ($(window).width() > 1007) {
                    $(".ShopTheLook__Dot.is-active").trigger("click");
                }
            });

            if ($(".arrows-ShopTheLook").length) {
                $(".arrows-ShopTheLook .flickity-prev-next-button.previous").on("click", function () {
                    flkty.previous();
                });
                $(".arrows-ShopTheLook .flickity-prev-next-button.next").on("click", function () {
                    flkty.next();
                });
            }

            function numberSlide(index_slide) {
                if ($(".arrows-ShopTheLook .number_slide").length) {
                    $(".arrows-ShopTheLook .current_slide").text(index_slide);
                }
            }
        }
    },
    SlideNewsBar: function () {
        if ($(".Slide_NewsBar").length) {
            var slickElement = $(".Slide_NewsBar");
            var status = $(".c-newsbar__number");
            slickElement.on('init reInit afterChange', function (event, slick, currentSlide, nextSlide) {
                //currentSlide is undefined on init -- set it to 0 in this case (currentSlide is 0 based)
                var i = (currentSlide ? currentSlide : 0) + 1;
                status.html('<span>' + i + '</span> / <span>' + slick.slideCount + '</span>');
            });
            slickElement.slick({
                infinite: false,
                speed: 300,
                slidesToShow: 1,
                nextArrow: ".c-newsbar__arrowright",
                prevArrow: ".c-newsbar__arrowleft",
            });
        }
    },
    SlideSpecial: function () {
        var $slider = $('.Slide_Special');
        var $progressBar = $('.slider__special__progress');
        var $progressBarLabel = $('.slider__label__special');
        var $itemToShow = 3;

        $slider.on('init', function (event, slick, currentSlide, nextSlide) {
            // console.log(slick);
            var calc = ((1) / ((slick.slideCount + 1) - (slick.options.slidesToShow))) * 100;

            $progressBar
                .css('background-size', calc + '% 100%')
                .attr('aria-valuenow', calc);

            $progressBarLabel.text(calc + '% completed');
        });

        $slider.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
            // console.log(slick);
            var calc = ((nextSlide + 1) / ((slick.slideCount + 1) - (slick.options.slidesToShow))) * 100;

            $progressBar
                .css('background-size', calc + '% 100%')
                .attr('aria-valuenow', calc);

            $progressBarLabel.text(calc + '% completed');
        });

        $slider.slick({
            slidesToShow: 3,
            slidesToScroll: 1,
            infinite: false,
            arrows: true,
            dots: false,
            draggable: true,
            appendArrows: '.slider__special-arrow',
            waitForAnimate: false,
            nextArrow: ".slider__special-arrow .c-special__arrowright",
            prevArrow: ".slider__special-arrow .c-special__arrowleft",
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        arrows: true,
                        slidesToShow: 1,
                        centerMode: true,
                        infinite: true,
                        centerPadding: '27.5px'
                    }
                }
            ]
        });
    },
    SlideShopNow: function () {
        var $slider = $('.Slide_ShopNow');
        var $progressBar = $('.slider__shopnow__progress');
        var $progressBarLabel = $('.slider__label__shopnow');
        var $itemToShow = 3;

        $slider.on('init', function (event, slick, currentSlide, nextSlide) {
            // console.log(slick);
            var calc = ((1) / ((slick.slideCount + 1) - (slick.options.slidesToShow))) * 100;

            $progressBar
                .css('background-size', calc + '% 100%')
                .attr('aria-valuenow', calc);

            $progressBarLabel.text(calc + '% completed');
        });

        $slider.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
            // console.log(slick);
            var calc = ((nextSlide + 1) / ((slick.slideCount + 1) - (slick.options.slidesToShow))) * 100;

            $progressBar
                .css('background-size', calc + '% 100%')
                .attr('aria-valuenow', calc);

            $progressBarLabel.text(calc + '% completed');
        });

        $slider.slick({
            slidesToShow: 3,
            slidesToScroll: 1,
            infinite: false,
            arrows: true,
            dots: false,
            draggable: true,
            appendArrows: '.slider__shopnow-arrow',
            waitForAnimate: false,
            nextArrow: ".slider__shopnow-arrow .c-special__arrowright",
            prevArrow: ".slider__shopnow-arrow .c-special__arrowleft",
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        arrows: true,
                        slidesToShow: 1
                    }
                }
            ]
        });
    },
    SlideProductRecommendations: function () {
        var $sliderRecommendations = $('.Slide_Product_Recommendations');
        var $progressBarRecommendations = $('.slide_Product_Recommendations__progress');
        var $progressBarLabelRecommendations = $('.slide_Product_Recommendations__label');
        var $itemToShow = 3;

        $sliderRecommendations.on('init', function (event, slick, currentSlide, nextSlide) {
            // console.log(slick);
            var calc = ((1) / ((slick.slideCount + 1) - (slick.options.slidesToShow))) * 100;

            $progressBarRecommendations
                .css('background-size', calc + '% 100%')
                .attr('aria-valuenow', calc);

            $progressBarLabelRecommendations.text(calc + '% completed');
        });

        $sliderRecommendations.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
            // console.log(slick);
            var calc = ((nextSlide + 1) / ((slick.slideCount + 1) - (slick.options.slidesToShow))) * 100;

            $progressBarRecommendations
                .css('background-size', calc + '% 100%')
                .attr('aria-valuenow', calc);

            $progressBarLabelRecommendations.text(calc + '% completed');
        });

        $sliderRecommendations.slick({
            slidesToShow: 3,
            slidesToScroll: 1,
            infinite: false,
            arrows: true,
            dots: false,
            draggable: true,
            appendArrows: '.slide_Product_Recommendations-arrow',
            waitForAnimate: false,
            nextArrow: ".slide_Product_Recommendations-arrow .c-special__arrowright",
            prevArrow: ".slide_Product_Recommendations-arrow .c-special__arrowleft",
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        arrows: true,
                        slidesToShow: 1,
                        centerMode: true,
                        infinite: true,
                        centerPadding: '27.5px'
                    }
                }
            ]
        });
    },
    SlideProductRecommendationsShopify: function () {
        var $sliderRecommendations = $('.Slide_Product_Recommendations_Shopify');
        var $progressBarRecommendations = $('.slide_Product_Recommendations__Shopify__progress');
        var $progressBarLabelRecommendations = $('.slide_Product_Recommendations__Shopify__label');
        var $itemToShow = 3;

        $sliderRecommendations.on('init', function (event, slick, currentSlide, nextSlide) {
            // console.log(slick);
            var calc = ((1) / ((slick.slideCount + 1) - (slick.options.slidesToShow))) * 100;

            $progressBarRecommendations
                .css('background-size', calc + '% 100%')
                .attr('aria-valuenow', calc);

            $progressBarLabelRecommendations.text(calc + '% completed');
        });

        $sliderRecommendations.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
            // console.log(slick);
            var calc = ((nextSlide + 1) / ((slick.slideCount + 1) - (slick.options.slidesToShow))) * 100;

            $progressBarRecommendations
                .css('background-size', calc + '% 100%')
                .attr('aria-valuenow', calc);

            $progressBarLabelRecommendations.text(calc + '% completed');
        });

        $sliderRecommendations.slick({
            slidesToShow: 3,
            slidesToScroll: 1,
            infinite: false,
            arrows: true,
            dots: false,
            draggable: true,
            appendArrows: '.slide_Product_Recommendations-arrow',
            waitForAnimate: false,
            nextArrow: ".slide_Product_Recommendations__Shopify-arrow .c-special__arrowright",
            prevArrow: ".slide_Product_Recommendations__Shopify-arrow .c-special__arrowleft",
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        arrows: true,
                        slidesToShow: 1,
                        centerMode: true,
                        infinite: true,
                        centerPadding: '27.5px'
                    }
                }
            ]
        });
    },
    HideProgressBar: function () {
        // =======================================================================================================================
        // Set hide progress bar when not enough product
        setTimeout(function () {
            if ($("div[role='progressbar']").length) {
                $("div[role='progressbar']").each(function (index, val) {
                    if (!$(val).parents(".c-recently-viewed-products__bottom-box").length) {
                        var progress = $(val).attr("aria-valuenow");
                        if (progress == undefined || progress < 0 || progress == 100 || progress == 'Infinity') {
                            $(val).hide();
                        }
                    }
                });
            }
        }, 0);
        // End
        // =======================================================================================================================
    },
    ShopLookContainer: function () {
        if ($(".ShopLook").length && $(window).width() > 1007) {
            var marleft = ($(window).width() - $(".ShopLook").width()) / 2;
            $(".ShopTheLook").css({
                "max-width:": "100%",
                "margin-left": marleft + "px"
            });
        } else {
            $(".ShopTheLook").css({
                "max-width:": "100%",
                "margin-left": "0"
            });
        }
    },
    menubarScroll: function () {
        $(window).on("scroll", function () {
            if ($(window).scrollTop() > 0) {
                $("#shopify-section-header").addClass("menu-sticky");
            } else {
                $("#shopify-section-header").removeClass("menu-sticky");
            }
        });
    },
    scrollTop: function () {
        if ($(".c-scroll_top").length) {
            $(".c-scroll_top").on("click", function () {
                $("html, body").animate({ scrollTop: 0 }, 1000);
            });
        }
    },
    buttonAddtoCartProduct: function () {
        if ($(".movetocart").length) {
            var screenScroll = $(window).scrollTop() + $(window).innerHeight();
            if (screenScroll < $(".Product-Custom__Contains").offset().top) {
                $(".movetocart").addClass("is_fixed");
            } else {
                $(".movetocart").removeClass("is_fixed");
            }
            $(window).on("scroll", function () {
                var screenScroll = $(window).scrollTop() + $(window).innerHeight();
                if (screenScroll < $(".Product-Custom__Contains").offset().top) {
                    $(".movetocart").addClass("is_fixed");
                } else {
                    $(".movetocart").removeClass("is_fixed");
                }
            });

            $('.movetocart').on('click',function(){
                $('html,body').animate({
                    scrollTop: $(".Product-Custom__Contains").offset().top
                }, 'slow');
            });
        }
    },
  noShiCusomeSelect: function () {
    var noShiCusomeSelect = setInterval(function () {
            if ($('.template-product').length) {
                if ($("#gsAppContainer").length) {
                    clearInterval(noShiCusomeSelect);
                    $("#slct").empty();
                    $('#gsAppContainer').css({
                      'position': 'absolute',
                      'opacity': '0',
                      'z-index': '-999'
                    });
                    $("#slct").html($('#gsAppContainer select[name="properties[noshi-option]"]').html());
                    // $('.line-item-property__field input[name="properties[noshi-option]"]').each(function (index, val) {
                    //     $(val).prop('checked', false);
                    //     $(val).removeAttr('required');
                    //     var value = $(val).val();
                    //     var noshiId = $(val).attr("id");
                    //     var option = document.createElement('option');
                    //     option.value = value;
                    //     if(value == '無し'){
                    //         option.innerHTML = '掛紙の種類を選択してください';
                    //     }else{
                    //         option.innerHTML = value;
                    //     }
                    //     option.setAttribute("data-id", noshiId);
                    //     $("#slct").append(option);
                    // });

                    if ($("#slct").length) {
                        $("#slct").on('change', function () {
                            var element = $(this).find('option:selected');
                            $('#gsAppContainer select[name="properties[noshi-option]"] option' ).removeAttr('selected');
                            var myTag = element.attr('value');
                            $('#gsAppContainer select[name="properties[noshi-option]"] option[value="'+ myTag +'"]' ).attr('selected','selected');
                        });
                    }

                    if ($('#text02').length) {
                        $('#text02').on('keyup', function () {
                            $('#gsAppContainer input[name="properties[noshi-name]"]').val($(this).val());
                        });
                    }
                }
            }
        }, 200);
    },
    openNoshi: function () {
        if ($('.template-product').length) {
            var OptionsApp = setInterval(function () {
                if ($('.hulkapps_radio_option').length) {
                    clearInterval(OptionsApp);
                    $('.hulkapps_radio_option').first().find('input').trigger('click');
                    $('.hulkapps_radio_option .hulkapps_option_child').on('click', function () {
                        var last = $('.hulkapps_radio_option').last().find('.hulkapps_option_child').val();
                        if ($(this).val() == last) {
                            $('.ProductService02').slideDown();
                            $('.line-item-property__field input[name="properties[noshi-option]"]').each(function (index, val) {
                                if ($(val).attr('id') == $("#slct").find('option:selected').attr("data-id")) {
                                    $(val).prop("checked", true);
                                }
                            });
                        } else {
                            $('.ProductService02').slideUp();
                            $('.line-item-property__field input[name="properties[noshi-option]"]').each(function (index, val) {
                                $(val).prop('checked', false);
                            });
                            $('#gsAppContainer input[name="properties[noshi-name]"]').val('');
                            $('#text02').val('');
                        }
                    });
                }
            }, 200);

//           var OptionsAppCheckbox = setInterval(function () {
//                 if ($('.hulkapps_check_option').length) {
//                     clearInterval(OptionsAppCheckbox);
//                     $('.hulkapps_check_option').first().find('input').trigger('click');
//                     $('.hulkapps_check_option .hulkapps_option_child').on('click', function () {
//                         var last = $('.hulkapps_check_option').last().find('.hulkapps_option_child').val();
//                         if($(this).val() == 'オプション無し'){
//                           $(this).parent().nextAll().find('input').prop('checked',false);

//                           $('.ProductService02').slideUp();
//                           $('.line-item-property__field input[name="properties[noshi-option]"]').each(function (index, val) {
//                             $(val).prop('checked', false);
//                           });
//                           $('#gsAppContainer select[name="properties[noshi-option]"] option[value="無し"]' ).attr('selected','selected');
//                           $('#gsAppContainer input[name="properties[noshi-name]"]').val('');
//                           $('#text02').val('');
//                         }

//                         if($(this).val() == "包装紙(有料) [ ¥100.00 ]"){
//                           	$('.hulkapps_check_option').first().find('.hulkapps_option_child').prop('checked',false);
//                         }

//                         if ($(this).val() == last) {
//                           if($(this).prop('checked') == true){
//                             $('.hulkapps_check_option').first().find('.hulkapps_option_child').prop('checked',false);
//                           	$('.ProductService02').slideDown();
// //                             $('.line-item-property__field input[name="properties[noshi-option]"]').each(function (index, val) {
// //                                 if ($(val).attr('id') == $("#slct").find('option:selected').attr("data-id")) {
// //                                     $(val).prop("checked", true);
// //                                 }
// //                             });
//                             $('#gsAppContainer select[name="properties[noshi-option]"] option' ).removeAttr('selected');
//                             var myTag = $("#slct").find('option:selected').val();
//                             $('#gsAppContainer select[name="properties[noshi-option]"] option[value="'+ myTag +'"]' ).attr('selected','selected');
//                           }else{
//                            	$('.ProductService02').slideUp();
// //                             $('.line-item-property__field input[name="properties[noshi-option]"]').each(function (index, val) {
// //                                 $(val).prop('checked', false);
// //                             });
//                             $('#gsAppContainer select[name="properties[noshi-option]"] option' ).removeAttr('selected');
//                             $('#gsAppContainer input[name="properties[noshi-name]"]').val('');
//                             $('#text02').val('');
//                           }
//                         }

//                       if($('.hulkapps_check_option input[value="包装紙(有料) [ ¥100.00 ]"]').prop('checked') != true && $('.hulkapps_check_option input[value="'+ last +'"]').prop('checked') != true){
//                         $('.hulkapps_check_option').first().find('.hulkapps_option_child').prop('checked',true);
//                       }
//                     });
//                 }
//             }, 200);
        }
    },
    PopoverClick: function () {
        if ($('.Product__OffScreen .Popover__Value').length) {
            setTimeout(function () {
                var thisOption = '';
                $('.Product__OffScreen').find('.is-selected').each(function (index, val) {
                    thisOption += $(val).data('value');
                });
                var getquantity = $('.' + thisOption).val();
                if (getquantity != undefined) {
                    if (getquantity == 0) {
                        $("#quantity").empty();
                        var option = document.createElement('option');
                        option.value = getquantity;
                        option.innerHTML = getquantity;
                        $("#quantity").append(option);
                    } else if (getquantity > 0) {
                        $("#quantity").empty();
                        for (var i = 1; i <= getquantity; i++) {
                            var option = document.createElement('option');
                            option.value = i;
                            option.innerHTML = i;
                            $("#quantity").append(option);
                        }
                    }
                } else {
                    $("#quantity").empty();
                    var option = document.createElement('option');
                    option.value = 0;
                    option.innerHTML = 0;
                    $("#quantity").append(option);
                }

            }.bind($(this)), 0);
            $('.Popover__Value').on('click', function () {
                setTimeout(function () {
                    var thisOption = '';
                    $(this).parents('.Product__OffScreen').find('.is-selected').each(function (index, val) {
                        thisOption += $(val).data('value');
                    });
                    var getquantity = $('.' + thisOption).val();
                    if (getquantity != undefined) {
                        if (getquantity == 0) {
                            $("#quantity").empty();
                            var option = document.createElement('option');
                            option.value = getquantity;
                            option.innerHTML = getquantity;
                            $("#quantity").append(option);
                        } else if (getquantity > 0) {
                            $("#quantity").empty();
                            for (var i = 1; i <= getquantity; i++) {
                                var option = document.createElement('option');
                                option.value = i;
                                option.innerHTML = i;
                                $("#quantity").append(option);
                            }
                        }
                    } else {
                        $("#quantity").empty();
                        var option = document.createElement('option');
                        option.value = 0;
                        option.innerHTML = 0;
                        $("#quantity").append(option);
                    }
                }.bind($(this)), 0);
            });
        }
    },
    SlideInstagram: function () {
        if ($('.template-index').length) {
            var checkExistInstagram = setInterval(function () {
                var $item = $('#insta-feed a');
                if ($item.length) {
                    $('#insta-feed').parent().css('overflow', 'hidden');
                    $('#insta-feed').children('div').find('.slider-arrow').remove();
                    $('#insta-feed').children('div').slick({
                        slidesToShow: 3,
                        slidesToScroll: 1,
                        infinite: false,
                        arrows: false,
                        dots: false,
                        draggable: true,
                        waitForAnimate: false,
                        responsive: [
                            {
                                breakpoint: 768,
                                settings: {
                                    centerMode: true,
                                    arrows: false,
                                    slidesToShow: 1,
                                    infinite: true,
                                }
                            }
                        ]
                    });
                    clearInterval(checkExistInstagram);
                    // $('#insta-feed').append('<div class="c-insta-feed">'+
                    // '<div class="c-collection-list__button">'+
                    // '<a href="https://www.instagram.com/ledlenser_japan/" target="_blank" class="c-insta-feed__link c-collection-list__btn btn-hover1">フォローする</a>'+
                    // '</div>'+
                    // '</div>');
                }
            }, 100); // check every 100ms
        }
    },
    // ===================================================================================================
    // Search Bar
    SearchBar: function () {
        if ($("#SearchMenu").length) {
            var searchElement = document.getElementById('SearchMenu');
            var searchResultsElement = searchElement.querySelector('.Search__Results');
            var queryMap = {};
            $("#SearchMenu .c-form__input").on("keyup", function (event) {
                var _this24 = this;

                if (event.keyCode === 13) {
                    return;
                }

                // Unfortunately, fetch does not support as of today cancelling a request. As a consequence what we do is that we manually
                // keep track of sent requests, and only use the results of the last one
                var lastInputValue = event.target.value;

                if (lastInputValue === '') {
                    _resetSearch();
                    return;
                }

                var queryOptions = { method: 'GET', credentials: 'same-origin' };

                var queries = [fetch(window.routes.searchUrl + '?view=ajax&q=' + encodeURIComponent(lastInputValue) + '*&type=product', queryOptions)];

                if (window.theme.searchMode !== 'product') {
                    queries.push(fetch(window.routes.searchUrl + '?view=ajax&q=' + encodeURIComponent(lastInputValue) + '*&type=' + window.theme.searchMode.replace('product,', ''), queryOptions));
                }

                queryMap[lastInputValue] = true;

                document.dispatchEvent(new CustomEvent('theme:loading:start'));

                Promise.all(queries).then(function (responses) {
                    // If we receive the result for a query that is not the last one, we simply do not process the result
                    if (lastInputValue !== event.target.value) {
                        return;
                    }

                    delete queryMap[event.target.value];

                    Promise.all(responses.map(function (response) {
                        return response.text();
                    })).then(function (contents) {
                        // If we have only one content then we only have product, otherwise we have products and articles
                        if (window.theme.searchMode === 'product') {
                            searchResultsElement.innerHTML = contents[0];
                        } else {
                            searchResultsElement.innerHTML = '<div class="PageLayout PageLayout--breakLap">\n              <div class="PageLayout__Section">' + contents[0] + '</div>\n              <div class="PageLayout__Section PageLayout__Section--secondary">' + contents[1] + '</div>\n            </div>';
                        }

                        searchResultsElement.setAttribute('aria-hidden', 'false');
                    });

                    document.dispatchEvent(new CustomEvent('theme:loading:end'));
                });
            })

            function _resetSearch() {
                if (window.theme.searchMode === 'product') {
                    searchResultsElement.innerHTML = '';
                } else {
                    searchResultsElement.innerHTML = '<div class="PageLayout PageLayout--breakLap">\n              <div class="PageLayout__Section"></div>\n              <div class="PageLayout__Section PageLayout__Section--secondary"></div>\n            </div>';
                }

                searchResultsElement.setAttribute('aria-hidden', 'true');

                document.dispatchEvent(new CustomEvent('theme:loading:end')); // Just in case
            }
        }
    },
    // End
    // ===================================================================================================
  	ProductOptionApp:function(){
        var appendDiv = setInterval(() => {
            if($(".hulkapps_check_option").length){
                clearInterval(appendDiv);
                $(".hulkapps_check_option").each(function(index){
                    $(this).append('<div class="radio_div" for="'+ $(this).find('input').attr('id') +'">'+ $(this).text() +'</div>');
                    $(this).contents().filter(function(){ return this.nodeType != 1; }).remove();
                });
            }
        }, 200);
    }
}

$(document).ready(function () {
    App.SlideShow();
    App.SlideTheLook();
    App.SlideNewsBar();
    App.SlideSpecial();
    App.SlideShopNow();
    App.SlideProductRecommendations();
    App.SlideInstagram();

    if ($('.template-product').length) {
        var SlideProductRecommendationsShopify = setInterval(function () {
            if ($('.Slide_Product_Recommendations_Shopify').length) {
                clearInterval(SlideProductRecommendationsShopify);
                App.SlideProductRecommendationsShopify();
                App.HideProgressBar();
            }
        }, 200);
    }

    App.HideProgressBar();
    App.ShopLookContainer();
    App.menubarScroll();
    App.scrollTop();
    App.buttonAddtoCartProduct();
    App.noShiCusomeSelect();
    App.openNoshi();
    App.PopoverClick();
    App.SearchBar();
  	App.ProductOptionApp();

    $(".c-form").on("keypress", function (event) {
        var keyPressed = event.keyCode || event.which;
        if (keyPressed === 13) {
            event.preventDefault();
            return false;
        }
    });
});

$(window).on("load", function () {
    if ($(window).width() > 768 && $('.ShopTheLook').length) {
        var artHeight = $('.ShopTheLook__Inner').outerHeight();
        $('.ShopTheLook').children('.flickity-viewport').css({
            'height': artHeight
        });
        $('.ShopTheLook').children('.flickity-viewport').animate({ // quick and dirty
            'opacity': 1
        });
    }
});

$(window).on("load resize", function () {
    if ($(window).width() <= 768 && $('.template-blog').length) {
        var $sliderRecommendations = $('.Slide_Product_Recommendations');
        $sliderRecommendations.slick('unslick');
    }
    if ($(window).width() <= 768 && $('.template-product').length) {
        var SlideProductRecommendationsShopify = setInterval(function () {
            if ($('.Slide_Product_Recommendations_Shopify').length) {
                clearInterval(SlideProductRecommendationsShopify);
                var $sliderRecommendations = $('.Slide_Product_Recommendations_Shopify');
                $sliderRecommendations.slick('unslick');
            }
        }, 200);
    }
    if ($(window).width() <= 768) {
        if($('.c-special').length){
            $('.c-special').each(function(i,v){
                var imgHeight = $(this).find('img').innerHeight();
                $(this).find('.c-special__arrowleft').css('top',imgHeight / 2);
                $(this).find('.c-special__arrowright').css('top',imgHeight / 2);
            });
        }
    }else{
        if($('.c-special').length){
            $('.c-special').each(function(i,v){
                var imgHeight = $(this).find('img').innerHeight();
                $(this).find('.c-special__arrowleft').css('top',0);
                $(this).find('.c-special__arrowright').css('top',0);
            });
        }
    }
});

$(window).on("resize", function () {
    App.ShopLookContainer();
});


window.onload = function() {
    function foo() {
        $('.line-item-property__field').remove();
    }
    setInterval(foo, 100);
}

// 2023.3.1 Add  : Select first checkbox on FV
window.onpageshow = () => {
    const intervalId = setInterval(()=>{
        if(document.querySelector('.hulkapps_check_option')){
            clearInterval(intervalId);
            document.querySelector('.hulkapps_check_option').click();
        }
    },100);
};

// 2023.3.1 Add  : Click event on "掛紙" checkbox
window.addEventListener('DOMContentLoaded', () => {
    const intervalId = setInterval(()=>{
        if(document.querySelector('input[data-conditional-value="掛紙"]')){
            clearInterval(intervalId);
            document.querySelector('input[data-conditional-value="掛紙"]').addEventListener('change', (event) => {
                if(event.target.checked){
                    // when "掛紙" checkbox is checked
                    $('#gsAppContainer').css({
                        'position': 'static',
                        'opacity': '1',
                        'z-index': 'auto'
                      });
                }else{
                    // when "掛紙" checkbox isn't checked
                    $('#gsAppContainer').css({
                        'position': 'absolute',
                        'opacity': '0',
                        'z-index': '-999'
                      });
                }
            });
        }
    },100);
});